import { type Route } from '@angular/router';
import { OptOutPageComponent } from './components/optout-page/optout-page.component';

export const appRoutes: Route[] = [{ path: '', component: OptOutPageComponent }];
